import { usePermissionsStore } from '#layers/access/public';
import { useWorkspaceStore } from '#layers/workspace/public';

export function useWorkspaceContext() {
	const workspaceStore = useWorkspaceStore();
	const permissions = usePermissionsStore();

	async function ensureWorkspaceContext(workspaceSlug: string, opts: { fromWorkspaceRoute: boolean }) {
		await workspaceStore.hydrateWorkspace(workspaceSlug, opts);

		if (!permissions.isInitialized) {
			await permissions.initialize();
		}
	}

	return { ensureWorkspaceContext };
}
